import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function IconFrame({ title, children, ...props }) {
    return (_jsx("svg", { "aria-hidden": title ? undefined : true, "aria-label": title, fill: "none", height: "1em", role: title ? 'img' : undefined, stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8", viewBox: "0 0 24 24", width: "1em", ...props, children: children }));
}
export function UsersIcon(props) {
    return (_jsxs(IconFrame, { ...props, children: [_jsx("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }), _jsx("circle", { cx: "9", cy: "7", r: "4" }), _jsx("path", { d: "M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" })] }));
}
export function ShieldIcon(props) {
    return (_jsxs(IconFrame, { ...props, children: [_jsx("path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" }), _jsx("path", { d: "m9 12 2 2 4-4" })] }));
}
export function GroupsIcon(props) {
    return (_jsxs(IconFrame, { ...props, children: [_jsx("path", { d: "M3 3h6v6H3zM15 3h6v6h-6zM9 15h6v6H9z" }), _jsx("path", { d: "M6 9v3h12V9M12 12v3" })] }));
}
export function AuditIcon(props) {
    return (_jsxs(IconFrame, { ...props, children: [_jsx("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }), _jsx("path", { d: "M14 2v6h6M8 13h8M8 17h6" })] }));
}
export function SearchIcon(props) {
    return (_jsxs(IconFrame, { ...props, children: [_jsx("circle", { cx: "11", cy: "11", r: "8" }), _jsx("path", { d: "m21 21-4.35-4.35" })] }));
}
export function SunIcon(props) {
    return (_jsxs(IconFrame, { ...props, children: [_jsx("circle", { cx: "12", cy: "12", r: "4" }), _jsx("path", { d: "M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.66 6.34l1.41-1.41" })] }));
}
export function MoonIcon(props) {
    return (_jsx(IconFrame, { ...props, children: _jsx("path", { d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" }) }));
}
